import {workplaceTypes} from "../types";
import {ModalWindowContainerTotalAccCard} from "../Modal/ModalWindowContainerTotalAccCard";
import {ModalContainerWarningAccountingСards} from "../Modal/ModalContainerWarningAccountingCards"
import {ModalContainerTAC} from "../Modal/ModalContainerSignTotalAccCard";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import {isCanvasBlank} from "../functions";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import SignaturePad from "signature_pad";
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

export var FinalAccountingCardPage = {
    controller: function () {
        var self = this;

        this.countChange = 0;
        this.pendingCountChange = 0;
        this.newValue = new Map();
        this.pendingNewValue = new Map();
        this.readOnly = false;
        this.data = null;

        this.buildServicesXml = function () {
            let query = "<Records>";
            self.data.accountingCard.forEach(function (elem) {
                let value = elem.ServiceValue == null || elem.ServiceValue === '' ? 0 : elem.ServiceValue;
                query += "<Record ID=\"" + elem.ID + "\" Value=\"" + value + "\"/>";
            });
            return query + "</Records>";
        };

        this.buildPendingServicesXml = function () {
            let query = "<Records>";
            (self.data.servicesNotIncludedInSignedAccountingCard || []).forEach(function (elem) {
                let value = elem.ServiceValue == null || elem.ServiceValue === '' ? 0 : elem.ServiceValue;
                query += "<Record ID=\"" + elem.ID + "\" Value=\"" + value + "\"/>";
            });
            return query + "</Records>";
        };

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/accouting'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;
            self.data = response;

            let temp = {};
            let arr = response.accountingCard;
            for(let i = 0; i < arr.length; i++) {
                temp[arr[i]["ID"].toString()] = arr[i]["ServiceValue"];
            }
            localStorage.setItem("accountingCard", JSON.stringify(temp));

            let pendingTemp = {};
            let pendingArr = response.servicesNotIncludedInSignedAccountingCard || [];
            for(let i = 0; i < pendingArr.length; i++) {
                pendingTemp[pendingArr[i]["ID"].toString()] = pendingArr[i]["ServiceValue"];
            }
            localStorage.setItem("pendingAccountingCard", JSON.stringify(pendingTemp));

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            m.redraw();
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
            m.redraw();
        });

    },
    view: function (ctrl) {
        const data = ctrl.data;
        const isServiceAccountingList = /\/accounting\/tgo\/?$/.test(m.route());
        if (!data) {
            return m(".container.text-center[style='padding-top:40px']", [
                ctrl.errmsg || m("i.fa.fa-spinner.fa-spin.fa-3x"),
                ctrl.errmsg ? null : m("p[style='margin-top:10px']", "Загрузка листа учёта услуг...")
            ]);
        }
        const isAccountingCardLocked = data.accountingCardLocked === true;
        const correctionState = data.accountingCardCorrectionState || {};
        const servicesNotIncluded = data.servicesNotIncludedInSignedAccountingCard || [];
        const renderServiceValue = function (value) {
            return ((parseFloat(value) - Math.trunc(value)) == 0.0 ? Math.trunc(value) : value);
        };
        const handlePendingServiceChange = function (elem, event) {
            let oldValue = JSON.parse(localStorage.getItem("pendingAccountingCard")) || {};
            let defaultValue = renderServiceValue(oldValue[elem.ID]);
            if(defaultValue != event.currentTarget.value) {
                event.currentTarget.style.backgroundColor = "#dff0d8";
                if(!ctrl.pendingNewValue.has(elem.ID)) {
                    ctrl.pendingCountChange++;
                }
                ctrl.pendingNewValue.set(elem.ID, event.currentTarget.value);
                elem.ServiceValue = event.currentTarget.value;
            }
            else {
                event.currentTarget.style.backgroundColor = "#fff";
                if(ctrl.pendingNewValue.has(elem.ID)) {
                    ctrl.pendingNewValue.delete(elem.ID);
                    ctrl.pendingCountChange--;
                }
                elem.ServiceValue = event.currentTarget.value;
            }

            m.redraw.strategy("none");
        };
        const renderActionRow = function (label, button) {
            return m(".row[style='margin-top:6px']", [
                m(".col-xs-12.col-sm-8[style='text-align:right; padding:2px 7px;']", [
                    m("span[style='display:inline-block; line-height:1.25;']", label)
                ]),
                m(".col-xs-12.col-sm-4[style='text-align:right; padding:2px 7px;']", [
                    button
                ])
            ]);
        };

        return [
            m.component(HeaderMenuBlock, {
                time: data.time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: data.board,
                    menu: data.menu,
                    tasks: data.tasks,
                    currentTask: data.currentTask,
                    tab: 'works'
                })
            ]),
            m(".container[style='padding-top:10px']", [
                m("p.text-center", isServiceAccountingList
                    ? "ЛИСТ УЧЁТА УСЛУГ"
                    : "ФОРМИРОВАНИЕ ЛИСТА УЧЕТА УСЛУГ"),
                isServiceAccountingList ? m(".row", [
                    m(".col-xs-12[style='padding:2px 7px 10px 7px']", [
                        m("button.btn.btn-default.btn-lg[style='width:100%'][id='returnToTgo']", {
                            onclick: function () {
                                m.route('/task/' + m.route.param('taskId') + '/schedule');
                            }
                        }, "Вернуться к ТГО")
                    ])
                ]) : null,
                correctionState.isCorrection ? m(".alert.alert-warning.text-center", [
                    "Отображается корректировочный ЛУУ № " + correctionState.displayNumber + ". Полная актуальная версия."
                ]) : null,
                isAccountingCardLocked && !correctionState.isCorrection ? m(".alert.alert-info.text-center", [
                    "ЛУУ подписан. Редактирование значений услуг недоступно."
                ]) : null,
                isAccountingCardLocked && servicesNotIncluded.length > 0 ? m("div[style='margin:20px 0 25px 0']", [
                    m("p[style='margin:0 0 8px 0']", [
                        "После подписания ЛУУ добавлены услуги. Они не входят в подписанную версию."
                    ]),
                    m("table.table[style='margin-bottom:0']", [
                        m("tr", [
                            m("td.col-xs-10[style='padding:0 10px']", [
                                m("p.text-center", "Услуга")
                            ]),
                            m("td.col-xs-2[style='padding:0 10px']", [
                                m("p.text-left", "Значение")
                            ])
                        ]),
                        servicesNotIncluded.map(function (service) {
                            return m("tr", [
                                m("td.col-xs-10[style='padding:0 6px 0 10px']", [
                                    m("p.text-left.bg-danger[style='font-weight: normal !important;']", service.ServiceName)
                                ]),
                                m("td.col-xs-1[style='padding:0 6px 0 6px']", [
                                    m("input.form-control[type='number'][style='height: 34px; overflow:hidden;'][rows='1'][id='pending-input-"+service.ID+"']", {
                                        value: renderServiceValue(service.ServiceValue),
                                        onchange: handlePendingServiceChange.bind(null, service)
                                    })
                                ]),
                                m("td.col-xs-1[style='padding:10px 10px 0 6px']", [
                                    service.MessName
                                ])
                            ]);
                        })
                    ]),
                    m("p[style='margin:8px 0 0 0']", [
                        "Для подтверждения этих услуг нужно сформировать корректировочный ЛУУ."
                    ]),
                    renderActionRow("Сохранить изменения по значениям новых услуг",
                        m("button.btn.btn-info.btn-lg[style='width:100%'][id='savePendingChange']", {
                                disabled: ctrl.pendingCountChange == 0 ? "disabled" : "",
                                onclick: function () {
                                    let query = "<Records>";
                                    for (let pair of ctrl.pendingNewValue.entries()) {
                                        query += "<Record ID=\""+ pair[0] +"\" Value=\""+ pair[1] +"\"/>";
                                    }
                                    query += "</Records>";

                                    loader.show();
                                    m.request({
                                        method: 'PUT',
                                        url: '/api/task/' + m.route.param('taskId') + '/savePendingValueService',
                                        background: true,
                                        data: {xml: query}
                                    }).then(function (response) {
                                        let temp = {};
                                        let arr = response.servicesNotIncludedInSignedAccountingCard || [];
                                        for(let i = 0; i < arr.length; i++) {
                                            temp[arr[i]["ID"].toString()] = arr[i]["ServiceValue"];
                                            let input = document.getElementById("pending-input-"+arr[i]['ID'].toString());
                                            if (input) {
                                                input.style.backgroundColor = "#fff";
                                            }
                                        }
                                        localStorage.setItem("pendingAccountingCard", JSON.stringify(temp));
                                        ctrl.data.servicesNotIncludedInSignedAccountingCard = arr;
                                        ctrl.pendingNewValue.clear();
                                        ctrl.pendingCountChange = 0;

                                        loader.hide();
                                        m.redraw();
                                    }, function (response) {
                                        ctrl.errmsg = response && response.message
                                            ? m(".alert.alert-danger", response.message)
                                            : m(".alert.alert-danger", "Не удалось сохранить значения услуг.");
                                        loader.hide();
                                    });
                                }
                        }, "Сохранить")
                    ),
                    renderActionRow("Сформировать корректировочный ЛУУ",
                        m("button.btn.btn-warning.btn-lg[style='width:100%'][id='createCorrectionLuu']", {
                                onclick: function () {
                                    loader.show();
                                    m.request({
                                        method: 'POST',
                                        url: '/api/task/' + m.route.param('taskId') + '/createAccountingCardCorrection',
                                        background: true,
                                        data: {xml: ctrl.buildPendingServicesXml()}
                                    }).then(function (response) {
                                        let result = response.accountingCardCorrection;
                                        if (result["code"]) {
                                            ModalContainerWarningAccountingСards.open(result["content"], "contentWarringAccCard");
                                        } else {
                                            window.location.reload();
                                        }

                                        loader.hide();
                                        m.redraw();
                                    }, function (response) {
                                        ctrl.errmsg = response && response.message
                                            ? m(".alert.alert-danger", response.message)
                                            : m(".alert.alert-danger", "Не удалось сформировать корректировочный ЛУУ.");
                                        loader.hide();
                                        m.redraw();
                                    });
                                }
                        }, "Сформировать")
                    )
                ]) : null,
                m("table.table", [
                    m("tr", [
                        m("td.col-xs-10[style='padding:0 10px']", [
                            m("p.text-center", "Услуга")
                        ]),
                        m("td.col-xs-2[style='padding:0 10px']", [
                            m("p.text-left", "Значение")
                        ])
                    ]),
                    data.accountingCard.map(function(elem) {
                        let background = elem.PV == 'В' ? "bg-info" : "bg-danger";
                        let inputAttrs = {
                            value: renderServiceValue(elem.ServiceValue),
                            onchange: function (value) {
                                let oldValue = JSON.parse(localStorage.getItem("accountingCard"));
                                let defaultValue = renderServiceValue(oldValue[elem.ID]);
                                if(defaultValue != value.currentTarget.value) {
                                    value.currentTarget.style.backgroundColor = "#dff0d8";

                                    ctrl.newValue.set(elem.ID, value.currentTarget.value);
                                    elem.ServiceValue = value.currentTarget.value;

                                    ctrl.countChange++;
                                }
                                else {
                                    value.currentTarget.style.backgroundColor = "#fff";
                                    if(ctrl.newValue.has(elem.ID)) {
                                        ctrl.newValue.delete(elem.ID);
                                        elem.ServiceValue = value.currentTarget.value;
                                    }
                                    ctrl.countChange--;
                                }

                                if(ctrl.countChange == 0)
                                    document.getElementById("saveChange").disabled = "disabled";
                                else
                                    document.getElementById("saveChange").disabled = "";

                                m.redraw.strategy("none");
                            }
                        };
                        if (isAccountingCardLocked || ctrl.readOnly) {
                            inputAttrs.readonly = "readonly";
                        }
                        return m("tr", [
                            m("td.col-xs-10[style='padding:0 6px 0 10px']", [
                                m("p.text-left."+background+"[style='font-weight: normal !important;']", elem.ServiceName)
                            ]),
                            m("td.col-xs-1[style='padding:0 6px 0 6px']", [
                                m("input.form-control[type='number'][style='height: 34px; overflow:hidden;'][rows='1'][id='input-"+elem.ID+"']", inputAttrs)
                            ]),
                            m("td.col-xs-1[style='padding:10px 10px 0 6px']", [
                                elem.MessName
                            ])
                        ])
                    })
                ]),

                (isAccountingCardLocked || ctrl.readOnly) ? null : renderActionRow("Отправить изменения по значениям услуг",
                    m("button.btn.btn-info.btn-lg[style='width:100%'][id='saveChange']", {
                            disabled: ctrl.countChange == 0 ? "disabled" : "",
                            onclick: function () {
                                let query = "<Records>";
                                for (let pair of ctrl.newValue.entries()) {
                                    query += "<Record ID=\""+ pair[0] +"\" Value=\""+ pair[1] +"\"/>";
                                }
                                query += "</Records>";

                                loader.show();
                                m.request({
                                    method: 'PUT',
                                    url: '/api/task/' + m.route.param('taskId') + '/saveValueService',
                                    background: true,
                                    data: {xml: query}
                                }).then(function (response) {

                                    let temp = {};
                                    let arr = response.accountingCard;
                                    for(let i = 0; i < arr.length; i++) {
                                        temp[arr[i]["ID"].toString()] = arr[i]["ServiceValue"];
                                        document.getElementById("input-"+arr[i]['ID'].toString()).style.backgroundColor = "#fff";
                                    }
                                    localStorage.setItem("accountingCard", JSON.stringify(temp));
                                    ctrl.data.accountingCard = response.accountingCard;

                                    document.getElementById("saveChange").disabled = "disabled";
                                    m.redraw.strategy("none");

                                    loader.hide();
                                });
                            }
                    },"Сохранить")
                ),
                renderActionRow("Посмотреть лист учета услуг",
                    m("button.btn.btn-info.btn-lg[style='width:100%'][id='preview']", {
                            onclick: function () {
                                let query = ctrl.buildServicesXml();

                                loader.show();
                                m.request({
                                    method: 'POST',
                                    url: '/api/task/' + m.route.param('taskId') + '/getPreviewAccCard',
                                    background: true,
                                    data: { xml: query }
                                }).then(function (response) {
                                    let html = response.htmlAccountingCard.replace('\r\n', '');
                                    ModalWindowContainerTotalAccCard.open(html, "ModalPreview");
                                    m.redraw.strategy("none");

                                    loader.hide();
                                });
                            },
                    }, "Просмотр")
                ),
                isAccountingCardLocked ? null : renderActionRow("Подписать лист учета услуг", [
                    m("div", [
                        ModalContainerTAC.init(),
                        m("button.btn.btn-info.btn-lg[style='width:100%'][id='signCard']", {
                            onclick: function () {
                                ModalContainerTAC.open("Подпись листа учета услуг");
                                var canvas = document.getElementById("canvasSignTotalAccCard");
                                if (canvas !== null) {
                                    var signaturePad = new SignaturePad(canvas, {
                                        backgroundColor: 'rgb(255, 255, 255)'
                                    });
                                }
                                document.getElementById("yesBtnModalSignTotalAccCard").addEventListener("click", function () {

                                    var canvas = document.getElementById("canvasSignTotalAccCard");
                                    if(isCanvasBlank(canvas) == false) {
                                        var signBase64;
                                        if (canvas !== null) {
                                            signBase64 = canvas.toDataURL('image/png', 0.7);
                                        }
                                        let sign = "<img width=\"150\" height=\"75\" src=\"" + signBase64 + "\">"

                                        loader.show();
                                        m.request({
                                            method: 'POST',
                                            url: '/api/task/' + m.route.param('taskId') + '/createAccountingCard',
                                            background: true,
                                            data: {
                                                sign: sign,
                                                xml: ctrl.buildServicesXml()
                                            }
                                        }).then(function (response) {
                                            if (response.signedAccountingCard["code"])
                                                ModalContainerWarningAccountingСards.open(response.signedAccountingCard["content"], "contentWarringAccCard");
                                            else {
                                                window.location.reload();
                                            }
                                            //alert(response.signedAccountingCard["content"]);
                                            //let html = response.signedAccountingCard.replace('\r\n', '');
                                            //ModalWindowContainerTotalAccCard.open(html, "ModalPreview");

                                            loader.hide();
                                        });
                                    }

                                    ModalContainerTAC.close();
                                });

                                m.redraw.strategy("none");
                            }
                        }, "Подписать")
                    ])
                ])
            ]),
            ModalWindowContainerTotalAccCard.init("ModalPreview"),
            ModalContainerWarningAccountingСards.init("ModalWarringAcc"),

        ];
    }
};
